"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useCallback } from "react";
import { useInView } from "@/hooks/useInView";
import { useOptimizedVideo } from "@/hooks/useOptimizedVideo";
import { useHlsPlayer } from "@/hooks/useHlsPlayer";
interface Props {
  readonly src: string;
  readonly showControls?: boolean | undefined;
  readonly disableClickHandler?: boolean | undefined;
}
const MediaDisplayVideo: React.FC<Props> = t0 => {
  const $ = _c(25);
  const {
    src,
    showControls: t1,
    disableClickHandler: t2
  } = t0;
  const showControls = t1 === undefined ? false : t1;
  const disableClickHandler = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      threshold: 0.1
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const [wrapperRef, inView] = useInView(t3);
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      pollInterval: 15000,
      maxRetries: 8,
      preferHls: true,
      exponentialBackoff: false
    };
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const {
    playableUrl,
    isHls
  } = useOptimizedVideo(src, t4);
  let t5;
  if ($[2] !== inView || $[3] !== isHls || $[4] !== playableUrl || $[5] !== src) {
    t5 = {
      src: playableUrl,
      isHls,
      fallbackSrc: src,
      autoPlay: inView
    };
    $[2] = inView;
    $[3] = isHls;
    $[4] = playableUrl;
    $[5] = src;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const {
    videoRef,
    isLoading
  } = useHlsPlayer(t5);
  let t6;
  let t7;
  if ($[7] !== videoRef) {
    t6 = () => {
      const vid = videoRef.current;
      if (!vid) {
        return;
      }
      vid.setAttribute("webkit-playsinline", "true");
      vid.setAttribute("x5-playsinline", "true");
    };
    t7 = [videoRef];
    $[7] = videoRef;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[10] !== inView || $[11] !== isLoading || $[12] !== videoRef) {
    t8 = () => {
      const vid_0 = videoRef.current;
      if (!vid_0 || isLoading) {
        return;
      }
      if (!inView) {
        vid_0.pause();
      } else {
        vid_0.play().catch(_temp);
      }
    };
    t9 = [inView, isLoading, videoRef];
    $[10] = inView;
    $[11] = isLoading;
    $[12] = videoRef;
    $[13] = t8;
    $[14] = t9;
  } else {
    t8 = $[13];
    t9 = $[14];
  }
  useEffect(t8, t9);
  let t10;
  if ($[15] !== disableClickHandler || $[16] !== videoRef) {
    t10 = e => {
      if (disableClickHandler) {
        return;
      }
      const vid_1 = videoRef.current;
      if (!vid_1) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      if (vid_1.paused) {
        vid_1.play().catch(_temp2);
      } else {
        vid_1.pause();
      }
    };
    $[15] = disableClickHandler;
    $[16] = videoRef;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const handleClick = t10;
  const t11 = showControls ? undefined : handleClick;
  let t12;
  if ($[18] !== showControls || $[19] !== t11 || $[20] !== videoRef) {
    t12 = <video ref={videoRef} className="tw-w-full tw-h-full tw-rounded-xl tw-object-contain" muted={true} loop={true} controls={showControls} playsInline={true} preload="auto" onClick={t11} />;
    $[18] = showControls;
    $[19] = t11;
    $[20] = videoRef;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== wrapperRef) {
    t13 = <div ref={wrapperRef} className="tw-w-full tw-h-full tw-relative">{t12}</div>;
    $[22] = t12;
    $[23] = wrapperRef;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
};
export default React.memo(MediaDisplayVideo);
function _temp() {}
function _temp2() {}